import React, { useEffect } from 'react';
import { useNavigate, Link as RouterLink } from 'react-router-dom';

// material-ui
import { Button, Grid, Typography, useMediaQuery, CircularProgress } from '@mui/material';
import AlertTitle from '@mui/material/AlertTitle';

import Logo from 'ui-component/Logo';
import { useTheme } from '@mui/material/styles';
import AuthFooter from 'ui-component/cards/AuthFooter';
import useMasterSurveyResponseStore from 'zustand_store/useMasterSurveyResponseStore';
import SurveyService from 'services/survey.service';
import AnimateButton from 'ui-component/extended/AnimateButton';
import BasicSuccessComponent from 'views/BasicSuccessComponent';

// assets

// ==============================|| AUTH3 - CHECK MAIL ||============================== //

const SurveySuccessPage = () => {
    const navigate = useNavigate();
    const theme = useTheme();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('sm'));
    // const [score, setScore] = React.useState(null);
    const [survey, setSurvey] = React.useState({});
    const [isSurveyDataLoaded, setIsSurveyDataLoaded] = React.useState(false);

    const surveyShortCode = useMasterSurveyResponseStore((state) => state.survey_short_code);
    const responseContainer = useMasterSurveyResponseStore((state) => state.responseContainer);

    const handleSurvey = async () => {
        const { data } = await SurveyService.getSurveyFromShortCode(surveyShortCode);
        setSurvey(data);
        //  handleSurveyScoreOnAssessment();
    };

    // I am effectively disabling this "Assessment" Survey feature because we don't have any clue what to do with it
    // const handleSurveyScoreOnAssessment = async (survey) => {
    //     if (survey.survey_type === 'Assessment' && responseContainer.responses.length > 0) {
    //         const scorePayload = responseContainer.responses.map((res) => ({
    //             choiceId: Number(res.answer.value),
    //             questionId: res.qID
    //         }));
    //         const { survey: response } = await SurveyService.assessAnswerScore({ choices: scorePayload });
    //         setScore(response.score);
    //     }
    // };

    useEffect(() => {
        handleSurvey();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (survey?.meta) {
            setIsSurveyDataLoaded(true);
        }
        setTimeout(() => {
            if (survey?.meta?.redirection_url) {
                window.location.href = survey?.meta?.redirection_url;
            }
        }, 5000);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [survey]);

    return (
        <>
            {(() => {
                if (!isSurveyDataLoaded) {
                    return (
                        <Grid
                            container
                            sx={{
                                minHeight: '100vh',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}
                        >
                            <CircularProgress />
                        </Grid>
                    );
                }

                if (survey?.meta?.thankyou_text) {
                    return (
                        <Grid
                            container
                            sx={{
                                minHeight: '100vh',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}
                        >
                            <Grid item xs={12} sx={{ textAlign: 'center' }}>
                                <AlertTitle dangerouslySetInnerHTML={{ __html: survey?.meta?.thankyou_text }} />
                            </Grid>
                        </Grid>
                    );
                }

                return (
                    <Grid container direction="column" justifyContent="flex-end" sx={{ minHeight: '100vh', backgroundColor: '#ecf0f1' }}>
                        <Grid item xs={12}>
                            {!survey?.meta?.thankyou_text && <BasicSuccessComponent />}
                        </Grid>
                    </Grid>
                );
            })()}
        </>
    );
};

export default SurveySuccessPage;
